import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonService } from "../../shared/common.service";
import { ApiService } from "../../api.service";

import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit, OnDestroy {
  isLoggedIn: boolean;
  userData: any;
  isSidebarVisible = false; // Sidebar hidden initially
  public expandedMenu: string | null = null;
  public activeSubmenuItem: string | null = null;
  private routerSubscription: Subscription;
  

  constructor(
    public commonService: CommonService,
    public router: Router,
    private apiService: ApiService
  ) { }

  ngOnInit(): void {
    this.isLoggedIn = this.commonService.isLoggedIn();
    this.userData = this.commonService.getUserData();
    
    // Set initial active state based on current URL
    this.determineActiveMenuItem(this.router.url);
    
    // Subscribe to router events to update active state on navigation
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.determineActiveMenuItem(event.url);
      });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  // Toggle which menu is expanded
  toggleMenu(menu: string) {
    this.expandedMenu = this.expandedMenu === menu ? null : menu;
  }

  // Set active submenu item (kept for backward compatibility)
  setActiveSubmenuItem(item: string) {
    this.activeSubmenuItem = item;
  }

  // Determine active menu item based on current URL
  private determineActiveMenuItem(url: string): void {
    // Reset active states
    this.activeSubmenuItem = null;
    this.expandedMenu = null;

    // Check for Access Management routes
    if (url.includes('/access-list')) {
      this.activeSubmenuItem = 'access-list';
      this.expandedMenu = 'AccessManagement';
      return;
    }

    // Check for User Management routes
    if (url.includes('/users-list') || url.includes('/view-user/') || url.includes('/users/add') || url.includes('/edit-user/')) {
      this.activeSubmenuItem = 'users-list';
      this.expandedMenu = 'UserManagement';
      return;
    }

    // Check for Study Management routes
    if (url.includes('/study-list')) {
      this.activeSubmenuItem = 'study-list';
      this.expandedMenu = 'StudyManagement';
      return;
    }

    if (url.includes('/ecrf-list') || url.includes('/build-ecrf') || url.includes('/ecrf-template/')) {
      this.activeSubmenuItem = 'build-ecrf';
      this.expandedMenu = 'StudyManagement';
      return;
    }

    if (url.includes('/site-list') || url.includes('/add-location')) {
      this.activeSubmenuItem = 'site-list';
      this.expandedMenu = 'StudyManagement';
      return;
    }

    if (url.includes('/study-crc-list')) {
      this.activeSubmenuItem = 'study-user-list';
      this.expandedMenu = 'StudyManagement';
      return;
    }

    if (url.includes('/subscriptions')) {
      this.activeSubmenuItem = 'subscriptions';
      this.expandedMenu = 'DataManagement';
      return;
    }

    if (url.includes('/data-view')) {
      this.activeSubmenuItem = 'data-view';
      this.expandedMenu = 'DataManagement';
      return;
    }

    if (url.includes('/query-view')) {
      this.activeSubmenuItem = 'query-view';
      this.expandedMenu = 'DataManagement';
      return;
    }

    if (url.includes('/audit-trail') && !url.includes('/system-audit-trail')) {
      this.activeSubmenuItem = 'audit-trail';
      this.expandedMenu = 'AuditTrail';
      return;
    }

    if (url.includes('/system-audit-trail')) {
      this.activeSubmenuItem = 'system-audit-trail';
      this.expandedMenu = 'AuditTrail';
      return;
    }

    // If no specific route matches, keep current state
  }

  // Toggle sidebar visibility
  toggleSideNav() {
    this.isSidebarVisible = !this.isSidebarVisible;
  }



  navigateTostudy(event?: Event){
    if (event) {
      event.stopPropagation();
    }
    this.router.navigate(['study-list']);
  }


  navigateToAccess(event?: Event){
    if (event) {
      event.stopPropagation();
    }
    this.router.navigate(['access-list']);
  }

  navigateToUser(event?: Event){
    if (event) {
      event.stopPropagation();
    }
    this.router.navigate(['users-list']);
  }
  navigateToSiteList(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.router.navigate(['site-list']);
  }
  // side-nav.component.ts
navigateToBuildEcrf(event?: Event) {
  if (event) {
    event.stopPropagation();
  }
  // Direct build-ecrf ki vellakunda ecrf-list ki redirect cheyyali
  this.commonService.navigateTo('/ecrf-list');
}
navigateToSubscriptions(event?: Event) {
  if (event) {
    event.stopPropagation();
  }
  this.router.navigate(['subscriptions']);
}
navigateToDataView(event?: Event) {
  if (event) {
    event.stopPropagation();
  }
  this.router.navigate(['data-view']);
}

navigateToQueryView(event?: Event) {
  if (event) {
    event.stopPropagation();
  }
  this.router.navigate(['query-view']);
}

navigateToAuditTrail(event?: Event) {
  if (event) {
    event.stopPropagation();
  }
  this.router.navigate(['audit-trail']);
}

navigateToSystemAuditTrail(event?: Event) {
  if (event) {
    event.stopPropagation();
  }
  this.router.navigate(['system-audit-trail']);
}


  navigateToCreateEcrf(event?: Event){
    if (event) {
      event.stopPropagation();
    }
    this.router.navigate(['build-ecrf']);
  }

  navigateToStudyUserList(event?: Event){
    if (event) {
      event.stopPropagation();
    }
    this.commonService.navigateTo('/study-crc-list');
  }

  // Role-based access control methods
  isCRO(): boolean {
    return this.userData && this.userData.designation === 'CRO';
  }

  isAdmin(): boolean {
    return this.userData && this.userData.designation === 'Admin';
  }

  isCRCOrCRO(): boolean {
    return this.userData && this.userData.designation === 'CRO' || this.userData.designation === 'CRC';
  }

  isCROOrAdmin(): boolean {
    return this.userData && this.userData.designation === 'CRO' || this.userData.designation === 'Admin';
  }

  isCRC(): boolean {
    return this.userData && this.userData.designation === 'CRC';
  }

  isMonitor(): boolean {
    return this.userData && this.userData.designation === 'Monitor';
  }

  isDataMonitor(): boolean {
    return this.userData && this.userData.designation === 'Data Manager';
  }

  isPI(): boolean {
    const d = (this.userData?.designation || '').toString().trim();
    return this.userData && (d === 'PI' || d === 'Principal Investigator');
  }

  // Check if user has limited access (CRC, Monitor, Data Manager, PI)
  hasLimitedAccess(): boolean {
    return this.isCRC() || this.isMonitor() || this.isDataMonitor() || this.isPI();
  }

  // Check if user can access study user list (all roles)
  canAccessStudyUserList(): boolean {
    return this.isCRO() || this.isCROStandardPremiumOrEnterprise() || this.hasLimitedAccess();
  }

  // Check if user is CRO_Standard, CRO_Premium, or CRO_Enterprise
  isCROStandardPremiumOrEnterprise(): boolean {
    return this.userData && (
      this.userData.designation === 'CRO_Standard' ||
      this.userData.designation === 'CRO_Premium' ||
      this.userData.designation === 'CRO_Enterprise'
    );
  }

  // Check if user can access User Management (CRO, CRO_Standard, CRO_Premium, CRO_Enterprise)
  canAccessUserManagement(): boolean {
    return this.isCRO() || this.isCROStandardPremiumOrEnterprise();
  }

  // Check if user can access Study Management (CRO, CRO_Standard, CRO_Premium, CRO_Enterprise, CRC, Monitor, Data Manager, PI)
  canAccessStudyManagement(): boolean {
    return this.isCRO() || this.isCROStandardPremiumOrEnterprise() || this.hasLimitedAccess();
  }

  // Check if user can access Data Management (CRO, Data Manager, Monitor, CRC, PI)
  canAccessDataManagement(): boolean {
    return this.isCRO() || this.isDataMonitor() || this.isMonitor() || this.isCRC() || this.isPI();
  }


}
